import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
const isMobile = window.innerWidth <= 768;
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
  },
  container: {
    width: "65rem",
    padding: "20px 60px",
    borderRadius: "20px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    position: "fixed",
    height: "33rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
    marginBottom: "20px",
    overflowY: "scroll", // Enable vertical scrolling
    scrollbarWidth: "none", // Hide the scrollbar for Firefox
  },
  inside: {
    width: isMobile ? "30rem" : "70rem",
    marginTop: "1.5rem",
    paddingLeft: "5rem ",
    paddingRight: "5rem ",
    borderRadius: "20px",

    position: "fixed",
    height: "30rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
    marginBottom: "20px",
    // Example maximum height for the scrollable area
    overflow: "scroll", // Enable vertical scrolling
    scrollbarWidth: "none", // Hide the scrollbar for Firefox
  },
  title: {
    fontSize: "1.1rem",
    fontWeight: "bold",
    marginBottom: "20px",
    textAlign: "center",
    position: "sticky",
    top: 0,
    zIndex: "1001",
  },
  description: {
    textAlign: "justify",
    fontSize: "0.775rem",
    color: "#5C5C5C",
  },
};

const TermsModal = ({ isOpen, onClose, UserId, Details, UserPhone }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const handleAcceptTerms = () => {
    // Perform any necessary actions or API calls here
    localStorage.setItem("UserPhone", UserPhone);
    navigate("/register");
    // Close the modal
    setTimeout(() => {
      onClose();
    }, 1000);
  };

  return (
    <>
      {isOpen && (
        <>
          <div style={styles.overlay} onClick={onClose}></div>
          <div style={styles.container}>
            <p style={styles.title}>{t("Terms and Conditions")}</p>
          </div>
          {i18n.language == "ar" ? (
            <>
              <div style={styles.inside}>
                <span style={styles.description}>
                  <span style={styles.TncHeading}>الشروط والأحكام</span>
                  <br />
                  <span className="font-extrabold">
                    تطبيق وخدمات ماى جينى للتجار – الشروط والأحكام
                  </span>
                  <br />
                  <span className="font-extrabold">تنبيه هام:</span> نرجو قراءة
                  شروط وأحكام تطبيق ماى جينى للتجار هذه (ويشار أليها فيما بعد بـ
                  "الاتفاقية") قبل الدخول إلى تطبيق وخدمات ماى جينى أو
                  استخدامها.
                  <br />
                  تبين هذه الاتفاقية الشروط والأحكام الخاصة بتطبيق وخدمات ماى
                  جينى للتجار حسبما تقدمها شركة مايجينى لتكنولوجيا المعلومات
                  شركة ذات مسئولية محدودة، سجل تجاري رقم 196874 وعنوانها: الدور
                  الأول فوق الأرضى بالعقار رقم 14-القطعة 14/1164 شارع الوليد بن
                  ثنيان السعود شيراتون النزهة-القاهرة أو أية شركة تابعة أو شقيقة
                  لها ("ماى جينى").
                  <br />
                  يخضع دخولكم إلى تطبيق وخدمات ماى جينى للتجار أو استخدامها في
                  جمهورية مصر العربية لهذه الاتفاقية بما فيها وعلى سبيل المثال
                  لا الحصر الشروط الخاصة بحفظ البيانات الشخصية ونقلها ومشاركتها
                  والسرية والملكية الفكرية والتعاملات مع الأطراف الثالثة
                  وتعويضاتها. في حالة عدم موافقتكم على هذه الاتفاقية أو رغبتكم
                  في عدم الاستمرار في استخدام تطبيق ماى جينى للتجار يجب عليكم
                  عدم الاستمرار في استخدام التطبيق أو الدخول على خدماته أو
                  استخدامها. استمراركم في الدخول إلى التطبيق واستخدام الخدمات
                  يعني موافقتكم على الالتزام بهذه الاتفاقية.
                  <br />
                  <span className="font-extrabold">
                    اتفاقية استخدام تطبيق وخدمات ماى جينى
                  </span>
                  <br />
                  ترتبط هذه الاتفاقية باستخدام التطبيق وخدمات ماى جينى المتاحة
                  على تطبيق ماى جينى طبقا لما هو مفصل أدناه.
                  <br />
                  <span className="font-extrabold">التمهيد</span>
                  <br />
                  حيث تدير ماي جيني منصّة ماي جيني الإلكترونية (يشار إليها فيما
                  بعد بـ "المنصّة")، وهي منصّة إلكترونية تتيح خدمة تلقي ودعم
                  بيانات التجار المتعلقة بالمبيعات والمشتريات ودورة جرد المخزون
                  وصلاحية المخزون وإدارته والحسابات بشكل دوري وتوصيل التجار
                  بالموردين، ومقدمي أو ميسري خدمات الدفع، وأسطول الشحن،
                  والعملاء، وحيث يرغب التاجر بالاستفادة من خدمات المنصّة، فقد
                  اتفق الطرفان على الالتزام بالأحكام والشروط الواردة في هذه
                  الاتفاقية.
                  <br />
                  <span className="font-extrabold">
                    المادة (1). المصطلحات والتعريفات
                  </span>
                  <br />
                  <span className="font-extrabold">
                    1.1 - الشركة (ماى جينى للتجار)
                  </span>
                  <br />
                  هي شركة مايجينى لتكنولوجيا المعلومات شركة ذات مسئولية محدودة،
                  سجل تجاري رقم 196874 وعنوانها: الدور الأول فوق الأرضى بالعقار
                  رقم 14-القطعة 14/1164 شارع الوليد بن ثنيان السعود شيراتون
                  النزهة-القاهرة.
                  <br />
                  <span className="font-extrabold">1.2 - المنصّة</span>
                  <br />
                  هي منصّة ماي جيني الإلكترونية بكل ما تحتويه من واجهات
                  إلكترونية وهي مملوكة لماي جيني وتتيح خدمة تلقي ودعم بيانات
                  التجار المتعلقة بالمبيعات والمشتريات ودورة جرد المخزون وصلاحية
                  المخزون وإدارته والحسابات بشكل دوري وتوصيل التجار بالموردين،
                  ومقدمي وميسري خدمات الدفع، وأساطيل الشحن، والعملاء.
                  <br />
                  <span className="font-extrabold">1.3 - التاجر</span>
                  <br />
                  الشخص الاعتباري أو الشركة أو أي كيان آخر مصرح له ومرخص له
                  بممارسة الأعمال التجارية وفقاً للوائح والقوانين المعمول بها في
                  جمهورية مصر العربية.
                  <br />
                  <span className="font-extrabold">1.4 - الخدمة</span>
                  <br />
                  إتاحة خدمة تلقي ودعم بيانات التجار المتعلقة بالمبيعات
                  والمشتريات ودورة جرد المخزون وصلاحية المخزون وإدارته والحسابات
                  بشكل دوري، وتقديم خدمات الصيانة والدعم والتحديثات للمنصة
                  والتدريب اللازم للتجار على كيفية استخدام المنصة وتوصيل التجار
                  بالموردين، ومقدمي أو ميسري خدمات الدفع، وأسطول الشحن، والعملاء
                  وتحصيل مستحقات التجار.
                  <br />
                  <span className="font-extrabold">
                    1.5 - مقابل أداء الخدمة
                  </span>
                  <br />
                  المقابل المتفق عليه لأداء الخدمات التي تقدمها ماي جيني لصالح
                  التاجر، متضمنة ضريبة القيمة المضافة وأية ضرائب مفروضة على
                  الخدمة.
                  <br />
                  <span className="font-extrabold">1.6 - الحساب البنكي</span>
                  <br />
                  حساب تنشئه وتديره ماي جيني لدى أحد البنوك المرخص لها من البنك
                  المركزي المصري ويتم تسوية مقابل أداء الخدمة فيه من التجار
                  لصالح ماي جيني بأي وسيلة دفع مرخص لها من البنك المركزي.
                  <br />
                  <span className="font-extrabold">1.7 - المورد</span>
                  <br />
                  أي مورد متعاقد مع ماي جيني بموجب عقد ساري والذي سوف يقدم خدمات
                  توريد منتجاته وخدماته للتاجر المتعاقد مع ماي جيني بموجب عقد
                  ساري من خلال المنصة.
                  <br />
                  <span className="font-extrabold">1.8 - أسطول الشحن</span>
                  <br />
                  أي كيان مرخص له من جهاز تنظيم النقل البري الداخلي والدولي
                  ("جهاز تنظيم النقل") لتقديم خدمات نقل البضائع مع مراعاة كافة
                  أحكام القانون وقواعد السلامة والأمان متعاقد مع ماي جيني لتقديم
                  خدمات نقل البضائع.
                  <br />
                  <span className="font-extrabold">
                    1.9 - مقدمي أو ميسري خدمات الدفع
                  </span>
                  <br />
                  أي كيان حاصل على ترخيص من البنك المركزي المصري ومتعاقد مع بنك
                  مرخص له داخل مصر لتقديم خدمات مقدمي أو ميسري خدمات الدفع.
                  <br />
                  <span className="font-extrabold">1.10 - العملاء</span>
                  <br />
                  كافة العملاء الذين يستخدمون المنصة للاستفادة من خدمات ومنتجات
                  التجار المقدمة على المنصة.
                  <br />
                  <span className="font-extrabold">
                    المادة (2). الإطار التعاقدي والإنهاء
                  </span>
                  <br />
                  2.1 - تتضمن هذه الاتفاقية الأحكام والشروط الأساسية التي تنظم
                  علاقة ماي جيني بالتاجر فيما يتعلق بتقديم الخدمة.
                  <br />
                  2.2 - تحتفظ ماى جينى بحق تعديل الأحكام والشروط المنشورة على
                  المنصّة بإرادتها المنفردة، على أن يتم إخطار التاجر إلكترونياً
                  (عن طريق البريد الإلكتروني) أو المنصة بالتعديل خلال (30) يوماً
                  من تاريخ نشر التعديل، وللتاجر حق انهاء هذه الاتفاقية بعد إخطار
                  ماي جيني مسبقاً برغبته في الإنهاء بمدة (30) يوم من تاريخ
                  الإخطار بالإنهاء وذلك دون الحاجة للحصول على حكم قضائي.
                  <br />
                  2.3 - للتاجر إنهاء التعاقد مع ماي جيني فورا إذا كان هنالك
                  أسباب جدية (وفق العرف والممارسات التجارية الشائعة)، على سبيل
                  المثال لا الحصر: - عيوب جوهرية قد تسفر عن إنهاء الخدمة. - دخول
                  غير مصرح به أو استنساخ للتطبيق. - محاولات اتلاف التطبيق بسوء
                  نية.
                  <br />
                  <span className="font-extrabold">
                    المادة (3). نطاق الاتفاقية وطبيعة العلاقة
                  </span>
                  <br />
                  3.1 - تنظم هذه الاتفاقية العلاقة بين ماي جيني والتاجر فيما
                  يتعلق بتسجيل التاجر على المنصّة للحصول على إتاحة خدمة تلقي
                  ودعم بيانات التجار المتعلقة بالمبيعات والمشتريات ودورة جرد
                  المخزون وصلاحية المخزون وإدارته والحسابات بشكل دوري، وتقديم
                  خدمات الصيانة والدعم والتحديثات للمنصة والتدريب اللازم للتجار
                  على كيفية استخدام المنصة وتوصيل التجار بالموردين، ومقدمي أو
                  ميسري خدمات الدفع، وأسطول الشحن، والعملاء. ولا تعتبر هذه
                  الاتفاقية بحد ذاتها اتفاقية شراكة أو وكالة أو اتفاقية استشارات
                  بين الطرفين.
                  <br />
                  3.2 - يوافق ويقر التاجر بأن ماي جيني لا تقدم أي خدمة توريد أو
                  بيع أو شراء منتجات أو خدمات توصيل أو خدمات دفع وإنما تقوم ماي
                  جيني بتوصيل التاجر بالمخازن الكترونياً وبالموردين وأساطيل
                  الشحن ومقدمي أو ميسري خدمات الدفع المتعاقدين مع ماي جيني لتمكن
                  التجار من ممارسة أعمالهم بشكل ميسر وينحصر دور ماي جيني في
                  التوصيل بين كل طرف وتقديم خدمات المنصة ذات العلاقة، والحصول
                  على مقابل أداء الخدمة المقرر بموجب هذه الاتفاقية.
                  <br />
                  <span className="font-extrabold">
                    المادة (4) تسجيل التاجر على المنصة
                  </span>
                  <br />
                  4.1 - لغرض تسجيل التاجر على المنصة يتعين على كل تاجر انشاء طلب
                  تسجيل، ويجب أن يكون التاجر منشأة مسجلة وفق الأنظمة/القوانين
                  السارية في جمهورية مصر العربية، ويلتزم بتحميل المستندات
                  والبيانات المطلوبة لإتمام طلب التسجيل على المنصة.
                  <br />
                  4.2 - بعد الانتهاء من طلب التسجيل وتحميل كافة البيانات
                  والمستندات المطلوبة الخاصة بالتسجيل على المنصّة إلكترونياً يتم
                  التواصل مع التاجر عن طريق ماي جيني لتحديد ميعاد لزيارة التاجر
                  لإتمام إجراءات فحص مخازن التاجر وتسجيل بضاعة التاجر ومخزونه
                  على التطبيق الكترونيا وتدريب العاملين على استخدام المنصة.
                  <br />
                  4.3 - يتمتع المستخدم الرئيسي بصلاحيات حساب التاجر وإنشاء
                  مستخدمين إضافيين، وعليه، فإن التاجر يتحمل مسؤولية حماية بيانات
                  المستخدم الرئيسي والمستخدمين الإضافيين. ويعتبر كل إجراء يتم
                  على المنصة باستخدام بيانات الدخول الرئيسية أو الإضافية مقبولاً
                  من قبل التاجر ويتبع التاجر كافة الإرشادات الخاصة بحماية
                  البيانات وكذلك الإجراءات المتبعة بالحماية الخاصة بالتشغيل من
                  قبل ماي جيني.
                  <br />
                  4.4 - قد يتطلب التمتع بخدمات ماي جيني استخدام خدمات جهات أخرى
                  كمقدمي خدمات الانترنت، ومقدمي خدمات الاستضافة، وتخزين البيانات
                  ومقدمي خدمات الدفع الالكتروني، المرخص لهم بالعمل وتخضع تلك
                  الخدمات للأحكام والشروط الخاصة بمقدمي تلك الخدمات، ولا تضمن
                  ماي جيني أية أضرار تنتج عن أداء أو عدم توفر خدمات الغير عند
                  الحاجة.
                  <br />
                  <span className="font-extrabold">
                    المادة (5) التزامات ماي جيني تجاه التاجر
                  </span>
                  <br />
                  5.1 - يتمتع التاجر فور تسجيله على المنصّة بالخدمات التالية
                  المتاحة للتاجر على المنصّة: الدخول على بيانات المبيعات
                  والمشتريات و المخزون على المنصة مراجعة تواريخ انتهاء الصلاحية
                  للمنتجات في حالة إدخال هذه البيانات على المنصة اصدار أمر شراء
                  من خلال المنصة اتاحة خدمة مايجينى لاختيار المورد لاصدار أوامر
                  شراء دورية ويجب في كل الأحوال أن تكون الخدمة المقدمة غير
                  مخالفة للأنظمة أو الآداب العامة أو القيم المجتمعية أو القوانين
                  واللوائح المعمول بها في جمهورية مصر العربية.
                  <br />
                  5.2 - تقدم ماي جيني للتاجر كافة الدعم وبيانات البيع والشراء
                  الخاصة بالمخزون وصلاحية المخزون وإدارته والمعاملات بشكل دوري
                  كل شهر من خلال المنصة مقابل الحصول على مقابل خدمة يتم الاتفاق
                  عليه بين مايجينى والتاجر.
                  <br />
                  5.3 - تلتزم ماي جيني بإرسال ممثليها للتاجر بغرض تدريبه وتدريب
                  موظفيه على استخدام المنصة.
                  <br />
                  5.4 - تلتزم ماي جيني بصيانة المنصة وعمل التحديثات والدعم
                  اللازم طوال سريان هذه الاتفاقية.
                  <br />
                  5.5 - تلتزم ماي جيني بالالتزام بكافة الأحكام والقوانين للقيام
                  بالأنشطة والخدمات المشار إليها في هذه الاتفاقية والقوانين في
                  جمهورية مصر العربية.
                  <br />
                  <span className="font-extrabold">
                    المادة (6) التزامات التاجر تجاه ماي جيني
                  </span>
                  <br />
                  6.1 - يلتزم التاجر بعدم تعطيل دفع المستحقات اللازمة عليه
                  كمقابل خدمات لماي جيني ومقدمي الخدمة لأسباب غير جدية أو
                  اعتراضات غير مسببة بشكل واضح، ويتحمل المسؤولية عن دفع أجر مقدم
                  الخدمة أو ماي جيني، ولماي جيني في حال ثبوت المماطلة غير
                  المبررة، إلغاء تسجيل التاجر أو تعليق حسابه أو تعليق حقه بانشاء
                  طلب خدمة جديد على المنصة، دون أدنى مسؤولية على ماي جيني.
                  وتحتفظ ماي جيني بحقها في اتخاذ الإجراءات القانونية التي تراها
                  مناسبة للحصول على مستحقاتها.
                  <br />
                  6.2 - يتعهد التاجر باتباع كافة الإرشادات الخاصة بحماية
                  البيانات وكذلك الإجراءات المتبعة بالحماية الخاصة بالتشغيل من
                  قبل ماي جيني. كما يتعهد التاجر بحماية خصوصية وسرية معلومات
                  عملائه وعدم مشاركتها مع الغير إلا في الحدود التي تتطلبها طبيعة
                  المهمة المتعاقد عليها أو بموجب موافقة كتابية مسبقة منهم.
                  <br />
                  6.3 - يتعهد التاجر بمنح ماي جيني الحق في استخدام والاحتفاظ
                  ونشر البيانات (باستثناء البيانات الشخصية) التي يتم جمعها من
                  التاجر ومشاركتها مع الغير وفقاً لإرادة ماي جيني سواء دون مقابل
                  أو بمقابل ومشاركتها مع عملاء ماي جيني وفقاً لإرادتها.
                  <br />
                  6.4 - يقر التاجر بأنه يحق لماي جيني استخدام وسائل الدفع
                  الالكتروني وميسري أو مقدمي خدمات الدفع في بيع مخزون التاجر عبر
                  المنصة وأن يقدم ماي جيني خدمات التحصيل لصالح التاجر. ويوافق
                  التاجر على سداد مستحقاته المالية دوريا المحصلة من ماي جيني
                  لصالح التاجر بعد خصم مقابل أداء الخدمة المتفق عليه لصالح ماي
                  جيني.
                  <br />
                  6.5 - يقر التاجر بأنه يحق لماي جيني استخدام أساطيل النقل
                  المتوفرة عبر المنصة لتوصيل المنتجات بمخزون التجار للعملاء
                  وفقاً للشروط والأحكام المحددة من قبل ماي جيني. يوافق التاجر
                  على إضافة تكاليف التوصيل للفاتورة الخاصة به المحصلة من ماي
                  جيني لصالح أسطول النقل بعد خصم مقابل أداء الخدمة المتفق عليه
                  لصالح ماي جيني.
                  <br />
                  6.6 - للحصول على هذه الخدمة يلتزم التاجر بتوريد طلبات العملاء
                  المؤكدة التي تم استلامها على المنصة.
                  <br />
                  6.7 - يقر التاجر بأنه يحق لماي جيني إضافة الدفع عند الاستلام
                  على المنصة لمبيعات التاجر. وتكون تكاليف التوصيل مضافة لفاتورة
                  التاجر ومحصلة عن طريق ماي جيني وفقاً لملحق (1) من هذا العقد.
                  <br />
                  <span className="font-extrabold">
                    المادة (7) التكاليف ومقابل أداء الخدمة
                  </span>
                  <br />
                  7.1 - تحصل ماي جيني من التاجر على مقابل أداء الخدمة الذى يتم
                  تحديده من خلال المنصة عند انشاء طلب الخدمة، ويتم دفع مقابل
                  أداء الخدمة لماي جيني أو مقدمي الخدمة بفاتورة ضريبية شاملة
                  القيمة المضافة. ويكون مقابل أداء الخدمة كما هو موضح في المرفق
                  أ.
                  <br />
                  7.2 - تؤكد ماي جيني أنه ليس هناك أي مقابل أداء للخدمة يتم دفعه
                  من قبل التاجر غير ما ذكر في هذه الاتفاقية.
                  <br />
                  7.3 - يتحمل التاجر ضريبة القيمة المضافة وفقاً للقوانين
                  واللوائح المعمول بها في هذا الشأن في جمهورية مصر العربية. ويتم
                  دفع مقابل أداء الخدمة في الحساب البنكي لماي جيني وتفاصيله
                  كالتالي (*)، ولماي جيني حق اقتطاع مقابل أداء الخدمة من المبالغ
                  المودعة في حسابها البنكي من قبل التاجر ودون الحاجة إلى موافقة
                  التاجر.
                  <br />
                  <span className="font-extrabold">
                    المادة (8) التكاليف ومقابل أداء الخدمة
                  </span>
                  <br />
                  8.1 - تحصل ماي جيني من التاجر على مقابل أداء الخدمة الذى يتم
                  تحديده من خلال المنصة عند انشاء طلب الخدمة، ويتم دفع مقابل
                  أداء الخدمة لماي جيني أو مقدمي الخدمة بفاتورة ضريبية شاملة
                  القيمة المضافة. ويكون مقابل أداء الخدمة كما هو موضح في المرفق
                  أ.
                  <br />
                  8.2 - تؤكد ماي جيني أنه ليس هناك أي مقابل أداء للخدمة يتم دفعه
                  من قبل التاجر غير ما ذكر في هذه الاتفاقية.
                  <br />
                  8.3 - يتحمل التاجر ضريبة القيمة المضافة وفقاً للقوانين
                  واللوائح المعمول بها في هذا الشأن في جمهورية مصر العربية. ويتم
                  دفع مقابل أداء الخدمة في الحساب البنكي لماي جيني وتفاصيله
                  كالتالي (*)، ولماي جيني حق اقتطاع مقابل أداء الخدمة من المبالغ
                  المودعة في حسابها البنكي من قبل التاج ودون الحاجة إلى موافقة
                  التاجر.
                  <br />
                  <span className="font-extrabold">
                    المادة (9) الملكية الفكرية
                  </span>
                  <br />
                  9.1 - تكون كافة حقوق الملكية الفكرية المتعلقة بالمنصّة ملكاً
                  لماي جيني وحدها، ويتضمن ذلك التصاميم، والشعار، والعلامات
                  التجارية، والواجهات، والأكواد البرمجية وشيفرات المصدر Source
                  Code، ومخططات تدفق العمل workflow، والنماذج، والمحتوى،
                  والمعلومات والبيانات التي يتم جمعها، والوثائق القانونية، وكل
                  عناصر المنصّة الفنية واللغوية والتقنية.
                  <br />
                  9.2 - لا تخول هذه الاتفاقية التاجر أية حقوق لاستخدام الحقوق
                  الملكية الفكرية المملوكة لماى جينى إلا في حدود استخدامه
                  للمنصّة، ولا يجوز له - بدون موافقة كتابية من ماي جيني - نسخ
                  محتواها أو تقليده أو إعادة إنتاجه، أو تفريغه في وسائط ورقية أو
                  إلكترونية، أو تعديله أو استخدام أي جزء من عناصر الملكية
                  الفكرية المحمية بموجب هذه الأحكام والشروط في غير ما ذكر هنا.
                  <br />
                  9.3 - تعتبر أية مقترحات يقدمها التاجر لتطوير المنصّة ملكاً
                  لماي جيني، ولا يجوز له المطالبة بأية تعويضات أو مستحقات أو
                  حقوق ملكية فكرية تتعلق بمخرجات تلك المقترحات.
                  <br />
                  9.4 - يحتفظ التاجر بكافة حقوق الملكية الفكرية الخاصة به
                  كالعلامة التجارية وغيرها، ولا يجوز لماي جيني - بدون موافقة
                  كتابية من التاجر - استخدام شعار التاجر أو ملكيته الفكرية إلا
                  في الحدود اللازمة لتقديم الخدمة له.
                  <br />
                  <span className="font-extrabold">
                    المادة (10) سرية المعلومات
                  </span>
                  <br />
                  10.1 - تعتبر المعلومات التي يحصل عليها التاجر بسبب استخدامه
                  للمنصّة سرية، ويشمل ذلك معلومات ماي جيني ومقدمي الخدمات
                  وبياناتهم وخبراتهم وتقييماتهم، ولا يجوز له الإفصاح عنها أو
                  مشاركتها مع الغير إلا بموافقة كتابية من ماي جيني.
                  <br />
                  <span className="font-extrabold">
                    المادة (11) الموافقات والاخطارات
                  </span>
                  <br />
                  11.1 - يوافق الطرفان على توجيه أية إخطارات متعلقة بهذه
                  الاتفاقية بالبريد الإلكتروني، ويعتبر الإخطار الإلكتروني
                  مستلماً من قبل من وجه له ومنتجاً لآثاره من وقت الإرسال، وبصرف
                  النظر عن تاريخ استلامه ما لم يثبت وجود خلل فني أدى إلى تأخر
                  التسليم.
                  <br />
                  <span className="font-extrabold">
                    المادة (12) القانون الواجب التطبيق وتسوية النزاعات
                  </span>
                  <br />
                  تخضع العلاقة بين الطرفين والمترتبة بموجب هذه الاتفاقية
                  والنزاعات التي قد تنشأ عنها للقوانين المعمول بها في جمهورية
                  مصر العربية، وفي حال نشوب نزاع بين الطرفين بشأن هذا العقد أو
                  تفسيره أو تنفيذه او إنهاؤه فإن ماي جيني ستبذل قصارى الجهد
                  لتسوية الأمر بطريقة ودية فإذا تعذر الوصول إلى حل ودي خلال (30)
                  ثلاثين يوماً يكون لأي من الطرفين اللجوء إلى التحكيم وفقا
                  لقواعد مركز القاهرة الإقليمي للتحكيم التجاري الدولي. ويكون عدد
                  المحكمين محكم واحد وينعقد التحكيم باللغة الإنجليزية في مدينة
                  القاهرة. ويكون حكم التحكيم نهائيا وملزما للأطراف.
                  <br />
                  <span className="font-extrabold">
                    المادة 13 لغة الاتفاقية
                  </span>
                  <br />
                  تحررت هذه الاتفاقية باللغتين العربية والانجليزية وفي حالة
                  الخلاف بين اللغتين ترجح اللغة العربية، كما يشهد الأطراف بأنهم
                  قد قرأوا وفهموا ووافقوا على أحكام وشروط هذه الاتفاقية على
                  النحو المبين بها.
                  {/* <br />
                  <span className="font-extrabold">
                    الملحق أ - رسوم خدمة myGINNE Digityal
                  </span>
                  <br />
                  يقوم بائع التجزئة بدفع رسوم شهرية لـ myGINNE بقيمة 400 جنيه
                  مصري (400 جنيه مصري). بدلاً من ذلك، يمكن أن يدفع بائع التجزئة
                  2,200 جنيه مصري لمدة ستة أشهر مقدماً أو 4,000 جنيه مصري لمدة
                  سنة واحدة مقدمًا لاستخدام المنصة */}
                </span>
                <div className="flex gap-5 mt-7 mb-7 justify-start">
                  <button
                    type="button"
                    className="w-[180px] h-[45px] bg-white text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
                    onClick={() => onClose()}
                  >
                    {t("cancel")}
                  </button>
                  <button
                    type="button"
                    className="w-[180px] h-[45px] bg-primaryBlue text-white rounded-lg font-semibold"
                    onClick={handleAcceptTerms}
                  >
                    {t("iaccept")}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div style={styles.inside}>
                <span style={styles.description}>
                  <span className=" font-extrabold">
                    Myginne Application for Retailers - Terms & Conditions
                  </span>
                  <br />
                  <span className=" font-extrabold">ATTENTION:</span> Please
                  read these Myginne for Retailers Terms and Conditions
                  (hereinafter referred to as the "Agreement") before accessing
                  or using the Myginne Application and services.
                  <br />
                  This Agreement sets out the terms and conditions applicable to
                  Myginne’s application for Retailers as provided by Myginne
                  INFOTECH a Limited Liability Company, Commercial register
                  number 196874 and its address is at First Floor above Ground
                  in Building no.14, Plot 14/1164 El Walid Ben Thanian El Saoud
                  Sheraton El Nozha-Cairo or any other affiliated or sister
                  company (hereinafter referred to as "Myginne").
                  <br />
                  <span className=" font-extrabold">
                    Article 1: Terms and Definitions
                  </span>
                  <br />
                  <span className=" font-extrabold">1.1. Platform:</span> is an
                  online platform along with its electronic interfaces, owned by
                  Myginne which shall provide receiving, supporting Retailer’s
                  data related to the sales, purchases, Inventory cycle,
                  Inventory expiry management and accounting on periodic basis
                  and connecting the Retailer with the Suppliers, Payment
                  Aggregators and Facilitators, Fleet Partners and Customers.
                  <br />
                  <span className=" font-extrabold">1.2. Myginne: </span>{" "}
                  Myginne INFOTECH a Limited Liability Company, Commercial
                  register number 196874 and its address is at First Floor above
                  Ground in Building no.14, Plot 14/1164 El Walid Ben Thanian El
                  Saoud Sheraton El Nozha, Cairo or any other affiliated or
                  sister company (hereinafter referred to as "Myginne").
                  <br />
                  <span className=" font-extrabold">1.3. Retailer:</span> The
                  juristic person, the partnership or any other entity that is
                  operating a retail store is licensed to perform commercial
                  affairs in accordance with the provisions of the laws and
                  regulations in Egypt.
                  <br />
                  <span className=" font-extrabold">1.4. Service:</span>{" "}
                  availing a platform to assist the Retailer with supporting
                  Retailer’s data related to the sales, purchases, Inventory
                  cycle, Inventory expiry management and accounting on periodic
                  basis, and providing maintenance support, and updates of the
                  Platform and proper training for the Retailers to use the
                  Platform and connecting the Retailer with the Suppliers,
                  Payment Aggregators or Facilitators, Fleet Partners and
                  Customers and collection of the Retailers receivables.
                  <br />
                  <span className=" font-extrabold">1.5. Service Fee:</span> The
                  fee agreed upon to perform the services provided by Myginne to
                  the Retailer, including Value Added Tax and all applicable
                  taxes.
                  <br />
                  <span className=" font-extrabold">1.6. Bank Account:</span> An
                  account created and managed by Myginne at a bank licensed by
                  the Central Bank of Egypt, through which the Service Fee is
                  settled from Retailers to the benefit of Myginne by any means
                  licensed by the Central bank of Egypt.
                  <br />
                  <span className=" font-extrabold">1.7. Supplier:</span> Any
                  Supplier having a valid agreement with Myginne who shall
                  provide its products and services to the Retailers having a
                  valid agreement with Myginne through the Platform.
                  <br />
                  <span className=" font-extrabold">
                    1.8. Fleet Partner:
                  </span>{" "}
                  Any entity licensed by the Land Transport Regulatory Authority
                  (“LTRA”) to provide delivery services of goods in compliance
                  with all the provisions of the Law and safety regulations
                  which has a contract with Myginne to provide delivery services
                  of goods.
                  <br />
                  <span className=" font-extrabold">
                    1.9. Payment Aggregators or Facilitators:
                  </span>{" "}
                  Any entity having its license from the Central Bank of Egypt
                  and which has a contract with a locally licensed bank in Egypt
                  to provide payment aggregators or facilitators services in
                  Egypt.
                  <br />
                  <span className=" font-extrabold">1.10. Customers:</span> All
                  the Customers using the Platform for Customers and benefiting
                  from the Retailer’s services and products displayed on the
                  Platform.
                  <br />
                  <span className=" font-extrabold">
                    Article 2: Contractual Framework & Termination{" "}
                  </span>
                  <br />
                  <span className=" font-extrabold">2.1</span> This Agreement
                  shall include the basic terms and conditions regulating the
                  relationship between Myginne and the Retailer with respect to
                  the provision of the Service.
                  <br />
                  <span className=" font-extrabold">2.2</span> Myginne reserves
                  the right to amend the Terms and Conditions published on the
                  Platform at its sole discretion, provided that the Retailer
                  shall be electronically notified (via email) or through the
                  Platform within 30 days from the date of publication of the
                  amendment. The Retailer is entitled to terminate this
                  Agreement after serving a prior notice to Myginne of its
                  desire to terminate the Agreement (30) days prior to
                  termination, without the need for a court ruling.
                  <br />
                  <span className=" font-extrabold">2.3</span> The Retailer is
                  entitled to terminate the contract immediately with Myginne if
                  there are serious reasons (according to the customary and
                  common business practices) including but not limited to:
                  <br />
                  Critical defaults that could lead to immediate termination of
                  the Service
                  <br />
                  Unauthorized access, or duplication of the application
                  <br />
                  Deliberate attempt to corrupt the application by mala fide
                  intentions
                  <br />
                  <span className=" font-extrabold">
                    Article 3: The Scope of the Agreement and Nature of
                    Relationship
                  </span>
                  <br />
                  <span className=" font-extrabold">3.1</span> This Agreement
                  shall govern the relationship between Myginne and the Retailer
                  with respect to availing receiving, supporting Retailer’s data
                  related to the sales, purchases, Inventory cycle, Inventory
                  expiry management and accounting on a periodic basis, and
                  providing maintenance support, and updates of the Platform and
                  proper training for the Retailers to use the Platform and
                  connecting the Retailer with the Suppliers, Payment
                  Aggregators or Facilitators, Fleet Partners and Customers.
                  This Agreement shall not, in itself, be deemed as a
                  partnership agreement, agency or consulting agreement between
                  the Parties.
                  <br />
                  <span className=" font-extrabold"> 3.2 </span> The Retailer
                  agrees and acknowledges that Myginne does not provide any
                  service of supply, sale or purchase of goods, delivery
                  services, or payment services. However, Myginne connects the
                  Retailer electronically with warehouses, the Suppliers, Fleet
                  Partners, Payment Aggregators or Facilitators contracting with
                  Myginne to enable the Retailers to operate their business
                  swiftly. The role of Myginne is limited to connecting each
                  party to the other party, providing the relevant Platform
                  services and obtaining its Service Fee prescribed under this
                  Agreement.
                  <br />
                  <span className=" font-extrabold">
                    Article 4: Registering and Onboarding the Retailer on the
                    Platform
                  </span>
                  <br />
                  <span className=" font-extrabold"> 4.1</span> For the purpose
                  of registering the Retailer on the Platform, each Retailer
                  should submit a registration request and must be an
                  establishment registered in accordance with the
                  laws/regulations applicable in the Arab Republic of Egypt, and
                  should upload electronically the required documents and data
                  for the completion of the registration request on the
                  Platform.
                  <br />
                  <span className=" font-extrabold">4.2</span> After finishing
                  the registration request and uploading all the data and
                  documents on the platform electronically, Myginne shall
                  contact the Retailer to set a date for the inspection of the
                  Retailer’s goods and warehouses and registering of the
                  Retailer’s Products and inventory on the Platform
                  electronically and for training the Retailer’s employees
                  regarding the usage of the platform.
                  <br />
                  <span className=" font-extrabold">4.3</span> The main user
                  shall have the authorization to manage the Retailer’s account
                  and is entitled to create additional users. Therefore, the
                  Retailer shall be responsible for protecting the data of the
                  main user and the additional users. Each action carried out on
                  the Platform by using the main or additional login data is
                  deemed acceptable by the Retailer and shall follow all
                  guidelines of data protection, safety, SOPs (standard
                  operating procedures) as prescribed by Myginne.
                  <br />
                  <span className=" font-extrabold">4.4</span> Using the
                  services of Myginne may require using the services of other
                  entities such as internet, hosting, data hosting, electronic
                  payment service providers. Those services are subject to the
                  terms and conditions of those service providers. Myginne does
                  not indemnify against any damage resulting from the
                  performance or non-availability of third-party services when
                  needed.
                  <br />
                  <span className=" font-extrabold">
                    {" "}
                    Article 6: Myginne’s obligations towards The Retailer
                  </span>
                  <br />
                  <span className=" font-extrabold">
                    {" "}
                    6.1 The Retailer shall, upon being registered on the
                    Platform, enjoy the following Services of the Platform
                    available to the Retailer:
                  </span>
                  <br />
                  Access to his sales, purchase, inventory data on the platform
                  <br />
                  div the expiry of products where such details are entered on
                  the platform Issuance of purchase order using the platform
                  Avail the Myginne choice of wholesaler service to place the
                  periodic Purchase order In all cases, the provided Service
                  shall not violate public order or morals, the society values
                  or the laws and regulations in force in the Arab Republic of
                  Egypt.
                  <br />
                  <span className=" font-extrabold">6.2</span> Myginne shall
                  provide to the Retailer support and data on sales, purchases,
                  Inventory cycle, Inventory expiry management and transactions
                  periodically each Month through the Platform against a service
                  fee to be agreed upon between Myginne and the Retailer.
                  <br />
                  <span className=" font-extrabold">6.3</span> Myginne shall
                  send its representatives to the Retailer in order to provide
                  the Retailer and its employees with training on the use of the
                  Platform.
                  <br />
                  <span className=" font-extrabold"> 6.4</span> Myginne shall
                  maintain the Platform and provide upgrades and support during
                  the validity period of this agreement.
                  <br />
                  <span className=" font-extrabold">6.5</span> Myginne shall
                  comply with all legal, statutory requirements for activities
                  under this Agreement as applicable under Egyptian Laws.
                  <br />
                  <span className=" font-extrabold">
                    Article 7: The Retailer’s obligations towards Myginne
                  </span>
                  <br />
                  <span className=" font-extrabold">7.1</span> The Retailer
                  shall not delay the payment of the dues payable by it as the
                  service fee to Myginne and service providers for non-serious
                  reasons or clearly unjustified objections. The Retailer shall
                  also be responsible for payment of Myginne’s due amounts or
                  Service providers. In case unjustified procrastination is
                  proven, Myginne may cancel the Retailers’ registration,
                  suspend its account or suspend its right to create a new
                  service request on the Platform, without any liability on
                  Myginne. Myginne reserves the right to take the legal action
                  that it deems appropriate to receive its dues.
                  <br />
                  <span className=" font-extrabold">7.2</span> The Retailer
                  undertakes to follow all guidelines of data protection,
                  safety, SOPs (standard operating procedures) as prescribed by
                  Myginne. The Retailer also undertakes to protect the
                  Customer’s privacy and the confidentiality of their
                  information and not to share it with any third parties, except
                  within the limits required by the nature of the contracted
                  duty or with their prior written consent.
                  <br />
                  <span className=" font-extrabold">7.3</span> The Retailer
                  undertakes that it grants Myginne the right to use, retain,
                  publish, share the data collected (except for Personal Data)
                  from Retailer with others as per the discretion of Myginne
                  free of charge or for a paid arrangement with Myginne’s
                  clients as per Myginne’s discretion.
                  <br />
                  <span className=" font-extrabold">7.4</span> The Retailer
                  acknowledges that Myginne has the right to use digital payment
                  gateways and payment aggregators or facilitators for the sale
                  of the Retailer’s inventory on the “Platform” and Myginne to
                  provide collection services for the benefit of the Retailer.
                  The Retailer agrees to periodic reimbursement of the amounts
                  collected by Myginne to the Retailer after deduction of
                  agreed-upon Service Fee.
                  <br />
                  <span className=" font-extrabold">7.5</span> The Retailer
                  acknowledges that Myginne has the right to use Fleet Partners
                  available on the Platform for delivery of the Retailer’s
                  inventory products on the “application” to the Customers as
                  per the terms and conditions defined by Myginne. The Retailer
                  agrees that such delivery Service Fee will be added to the
                  invoice value of the Retailer and collected by the Fleet
                  Partner and retained by Myginne after deduction of agreed-upon
                  Service Fee.
                  <br />
                  <span className=" font-extrabold">7.6</span>For obtaining this
                  Service, the Retailer is obligated to supply the confirmed
                  customers’ orders received on the platform. In case of
                  noncompliance by the Retailer, it is agreed between the
                  Parties that the Retailer shall pay Myginne a contractual
                  penalty in the amount of (*) for each incidence of breach
                  separately. Furthermore, in case of recidivism Myginne shall
                  have the right to either immediately suspend the Retailer’s
                  account or terminate the T&Cs without the need for
                  notification or obtaining a court order.
                  <br />
                  <span className=" font-extrabold">7.7</span> The Retailer
                  acknowledges that Myginne has the right to give the option of
                  “cash on delivery” on the “application” for the sales of the
                  Retailer. The Service Fee, if any, for such delivery will be
                  added to the invoice of the Retailer and collected by Myginne
                  and retained by them as per the Annex 1 of this Agreement.
                  <br />
                  <span className=" font-extrabold">7.8</span> Retailer agrees
                  that Myginne has the right to run promotional activities on
                  the Platform through licensed companies for providing
                  marketing (digital / conventional), SMS, e-mail, social media
                  messaging. Myginne has all rights to use the data (except for
                  Personal Data) collected on the Platform from Retailer to be
                  used for such promotional campaigns. Myginne also has the
                  right to charge the proportionate cost of such promotions to
                  the Retailer based on prior agreement with the Retailer. The
                  Retailer agrees that such promotional Service Fee will be
                  added to the invoice value of the Retailer and collected by
                  the Promotion companies and retained by Myginne after
                  deduction of agreed-upon Service Fee.
                  <br />
                  <span className=" font-extrabold">
                    Article 8: Costs and Service Fee
                  </span>
                  <br />
                  <span className=" font-extrabold">8.1</span> Myginne shall
                  receive from the Retailer the Service Fee determined through
                  the Platform upon the creation of the service request. The
                  Service Fee of Myginne and service providers shall be paid via
                  tax invoices including Value Added Tax. The Service Fee shall
                  be as mentioned in Annex A.
                  <br />
                  <span className=" font-extrabold">8.2</span> Myginne confirms
                  that there are no other Service Fees to be paid by the
                  Retailer other than the Service Fee mentioned in this
                  Agreement.
                  <br />
                  <span className=" font-extrabold">8.3</span> The Retailer
                  shall bear the Value Added Tax in accordance with the laws and
                  regulations in force in this regard in the Arab Republic of
                  Egypt. The Service Fee shall be paid in return for the
                  performance of the Service in Myginne’s bank account, the
                  details of which are as follows (*). Myginne is entitled to
                  deduct its Service Fee from the amounts deposited in its bank
                  account by the Retailer without the need for the Retailer’s
                  approval.
                  <br />
                  <span className=" font-extrabold">
                    {" "}
                    Article 9: Intellectual Property
                  </span>
                  <br />
                  <span className=" font-extrabold"> 9.1</span> All the
                  intellectual property rights relating to the Platform shall be
                  solely owned by Myginne, such as designs, logos, trademarks,
                  drawings, interfaces, software codes, source codes, workflow,
                  templates, content, collected information and data, legal
                  documents and all the technical technological and linguistic
                  elements of the Platform.
                  <br />
                  <span className=" font-extrabold">9.2</span> This Agreement
                  shall not grant the Retailer any rights to use the
                  intellectual property rights of Myginne except within the
                  limits of its use of the Platform. The Retailer shall not,
                  without prior written consent of Myginne, copy, imitate or
                  reproduce the Platform’s content, or copy it to any paper or
                  electronic media, or amend or use any part of the intellectual
                  property elements protected under these Terms and Conditions
                  for any purpose other than what is stated herein.
                  <br />
                  <span className=" font-extrabold">9.3</span> Any proposals
                  submitted by the Retailer to develop the Platform are deemed
                  the property of Myginne. The Retailer is not entitled to claim
                  any damages, dues or intellectual property rights relating to
                  the outputs of those proposals.
                  <br />
                  <span className=" font-extrabold">9.4</span> The Retailer
                  reserves all its intellectual property rights such as
                  trademarks and others. Myginne shall not, without the prior
                  written approval of the Retailer, use the Retailer’s logo or
                  its intellectual property except within the limits necessary
                  for providing the service thereto.
                  <br />
                  <span className=" font-extrabold">
                    Article 10: Confidentiality of Information
                  </span>
                  <br />
                  <span className=" font-extrabold">10.1</span> The information
                  received by the Retailer due to its use of the Platform shall
                  be confidential, including information on Myginne, the service
                  providers, their data, experience, and appraisals. It shall
                  not disclose or share this information with any third parties
                  unless with a written approval of Myginne.
                  <br />
                  <span className=" font-extrabold">
                    Article 11: Approvals and Notices
                  </span>
                  <br />
                  <span className=" font-extrabold">11.1</span> The Parties
                  agree to serve any notices relating to this Agreement via
                  email. The electronic notice is deemed received by the
                  recipient and effective as of the date of sending it,
                  regardless of the date of its receipt, unless it is proven
                  that a technical defect has led to delayed delivery.
                  <br />
                  <span className=" font-extrabold">
                    Article 12: The Applicable Law and Settlement of Disputes
                  </span>
                  <br />
                  The relationship between the Parties, resulting from this
                  Agreement and the disputes that may arise therefrom shall be
                  governed by the laws applicable in the Arab Republic of Egypt.
                  In case there is a dispute between the Parties over this
                  Agreement, its interpretation, execution, or termination
                  Myginne shall exert its best efforts to settle it amicably. In
                  case no amicable settlement is reached within (30) days,
                  either Party may refer the matter to arbitration under the
                  Rules of the Cairo Regional Centre for International
                  Commercial Arbitration (CRCICA). The number of arbitrators
                  shall be one. The arbitration shall be conducted in the
                  English language in the city of Cairo. The arbitration award
                  shall be final and binding upon the Parties.
                  <br />
                  <span className=" font-extrabold">
                    Article 13 Language of the Agreement
                  </span>
                  <br />
                  This Agreement was concluded in Arabic and English languages,
                  and in case of discrepancy between both languages, the Arabic
                  language shall prevail. The Parties also declare that they
                  have read, understood and agreed on the Terms and Conditions
                  of this Agreement as stated herein.
                  {/* <br />
                  <span className=" font-extrabold">
                    ANNEX – A
                    <br />
                    Annex A Myginne’s Service Fee and the Service Providers
                    Service Fee
                  </span>
                  <br />
                  The Retailer shall pay Myginne a Monthly Service Fees of EGP
                  100 (Egyptian Pounds One Hundred only inclusive of vat) for
                  usage of the My Ginny platform. */}
                </span>
                <div className="flex gap-5 mt-7 mb-7 justify-start">
                  <button
                    type="button"
                    className="w-[180px] h-[45px] bg-white text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
                    onClick={() => onClose()}
                  >
                    {t("cancel")}
                  </button>
                  <button
                    type="button"
                    className="w-[180px] h-[45px] bg-primaryBlue text-white rounded-lg font-semibold"
                    onClick={handleAcceptTerms}
                  >
                    {t("iaccept")}
                  </button>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default TermsModal;
